export const regexValidatorForUrl =
  /https?:\/\/(localhost|172\.\d{1,3}\.\d{1,3}\.\d{1,3})(:\d{1,5})?/;
